import { render, staticRenderFns } from "./DialogSendImage.vue?vue&type=template&id=63540785&scoped=true&"
import script from "./DialogSendImage.vue?vue&type=script&lang=ts&"
export * from "./DialogSendImage.vue?vue&type=script&lang=ts&"
import style0 from "./DialogSendImage.vue?vue&type=style&index=0&id=63540785&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63540785",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VDialog,VImg})
